import { BrowserStorage } from '@klickly/front-packages';
import { tokenStorage } from '@klickly/front-utils';
import { useCustomerId } from '../../../../../shared/hooks';

export const useMetaData = ({ publisherId, creditCardsLast4 }) => {
    const customerId = useCustomerId();

    const metadata = [
        {
            name: 'klpixel',
            data: {
                cid: BrowserStorage.get('_klpixel_cid'),
                hash: BrowserStorage.get('_klpixel_hash')
            }
        },
        {
            name: 'location',
            value: window.location.href
        },
        {
            name: 'publisherId',
            value: publisherId
        },
        {
            name: 'userId',
            value: customerId
        },
        {
            // CP-V2 canonical uid — kcp-api CreateKlicklyOrder reads this metadata
            // entry and persists it on the order, so the enricher can populate
            // cp_order_enriched.u / uids[]. Sourced from the `_kl_u` slots the
            // IdentityStore mints on boot via /auth/me (KLIC-11325). Without it
            // the DP order lands with u=null and is un-attributable in CP-V2.
            name: 'u',
            value: tokenStorage.read()
        }
    ];

    if (creditCardsLast4) {
        metadata.push({
            name: 'creditCardsLast4',
            value: creditCardsLast4
        });
    }

    return metadata;
};
